'use client';
import {useRef, useEffect} from "react";
import type {MouseEvent} from "react";
import styles from "./popover.module.css";

type PopoverProps = {
    items?: string[];
    children?: React.ReactNode;
    onChange?: (val: string) => void
}

const Popover: React.FC<PopoverProps> = ({children, items, onChange}) => {
    const popoverRef = useRef<HTMLDivElement>(null);
    const popoverContentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {

        document.addEventListener('click', handlePageClick);
        return () => {
            document.removeEventListener('click', handlePageClick);
        }
    }, []);

    const handlePageClick = (e: any) => {
        if (popoverRef.current && !popoverRef.current.contains(e.target)) {
            popoverContentRef.current && (popoverContentRef.current.style.display = 'none');
        }
    }

    const handlePopoverClick = () => {
        if (popoverRef.current) {
            const {x, y} = popoverRef.current?.getBoundingClientRect();

            const _elem = popoverContentRef.current;
            if (!_elem) return;

            _elem.style.display === 'block'
                ? _elem.style.display = 'none'
                : _elem.style.display = 'block';

            // if (_elem) {
            //   popoverContentRef.current.style.top = y + 'px';
            //   popoverContentRef.current.style.left = x + 'px';
            // }
        }
    }

    const handlePopoverItemClick = (e: MouseEvent<HTMLDivElement>, item: string) => {
        e.stopPropagation();
        const _elem = popoverContentRef.current
        _elem && (_elem.style.display = 'none');
        onChange && onChange(item);
    }

    return (
        <div
            ref={popoverRef}
            className={`${styles.popover}`}
            onClick={handlePopoverClick}
        >
            {children}
            <div
                ref={popoverContentRef}
                className={styles.dialog}
            >
                <div className={styles.dialog_content}>
                    <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                        {items && items.map((item) => (
                            <div
                                className={`${styles.item}`}
                                key={item}
                                onClick={(e: MouseEvent<HTMLDivElement>) => handlePopoverItemClick(e, item)}
                            >
                                +{item}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Popover;
